export default "__VITE_ASSET__af708516__"